<template>
    <div class="row proba col-md-12" id="timeline" @mousedown="onMouseDown($event)" @mouseup="onMouseUp($event)"
        style="padding:0; ">
        <div class="col1 col-sm-2" id="col1">
            <div class="col-md-12" id="after45">

            </div>
            <div id="before45" class="col-md-12">

            </div>

        </div>
        <div class="col2" id="col2">
            <div class="btn-group col-md-12 btn-group-vertical" id="start1">
                <button type="button" class="btn btn-default btn-sm" id="plusBtn" @click="zoomOnClick()"></button>
                <button type="button" class="btn btn-default btn-sm" id="minusBtn" @click="zoomOutClick()"></button>
                <button type="button" class="btn btn-default btn-sm" id="undoBtn" @click="undoOnClick()"></button>
            </div>
            <div id="start2" @mousedown="onMouseDown($event)" @mouseup="onMouseUp($event)">

            </div>
        </div>
        <div class="col3" id="col3">
            <div class="lineDiv">
                <div id="lineBox" class="row">
                    <div id="box"></div>
                </div>
                <div id="lineVert" class="row ">
                    <div id="vertLine"></div>
                </div>
                <div id="lineCont" class="row">
                    <div id="line"></div>
                </div>
                <div id="lineUnder" class="row" @mousedown="onMouseDown($event)" @mouseup="onMouseUp($event)">
                    <div id="under"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

window.$ = window.jQuery = require("jquery");
import axios from "axios";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";


export default {
    name: "Timeline",
    data() {
        return {
            baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
            baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,
            scale: 1,
            coordinatX1: 0,
            coordinatX2: 0,
            coordinatX3: 0,
            posActsInPx: [], // Replace with your data
            posYearsInPx: [], // Replace with your data
            yearsUnder: [], // Replace with your data
            currentYearInd: 0, // Replace with your data
            col3Width: 0,
            add: 0,
            indexFirstYear: 0,
            index: -1,
            startYear: 1945,
            dates: [],
            acts: [],
            url: window.location.href
        }
    },
    props: [
        'guid'
    ],
    mounted() {
        axios.get(this.baseREGApiUrl + "GetLawActTimeline?guid=" + this.guid).then((response) => {
            this.processActsData(response.data)
        }).catch(err => console.log(err))

        this.add = document.getElementById("col1").getBoundingClientRect().width + document.getElementById("col2").getBoundingClientRect().width;
        this.col3Width = document.getElementById("timeline").clientWidth - this.add;
        //document.getElementById("col3").style.width = this.col3Width + "px";
        var myNode = document.getElementById("box");
        myNode.innerHTML = "";
        myNode = document.getElementById("vertLine");
        myNode.innerHTML = "";
        myNode = document.getElementById("line");
        myNode.innerHTML = "";
        myNode = document.getElementById("under");
        myNode.innerHTML = "";
        const el = document.querySelector('#timeline');
        el.addEventListener('wheel', this.zoom);

    },
    methods: {
        processActsData(data) {
            // datumi izmena verzija akata
            this.acts = data;
            //regex koji proverava da li postoji /reg na kraju ili mozda postoji neki broj koji oznacava da se radi o nekoj verziji
            //jer ne mora u linku uvek da postoji /reg
            const regex = /\/(\d+)(?!.*\/\d+)|\/reg$/;

            const match = this.url.match(regex);
            if(match)
            this.versionDate = this.url.substring(match.index + 1, this.url.length);

            // da li se iza reg nalazi datum izmene verzije akta (njihovo staro, nase novo sa regex-om)
            // if (this.url.indexOf("/reg/") > -1) {
            //     this.versionDate = this.url.substring(this.url.indexOf("/reg") + 5, this.url.length);
            // }

            // datum izmene verzije akta
            // pozicija u nizu datuma izmene verzije akta
            if (this.versionDate !== null && this.versionDate !== undefined && this.versionDate !== "") {
                this.dateV = parseInt(this.versionDate.substring(6, 8)).toString() + "/" +
                    parseInt(this.versionDate.substring(4, 6)).toString() + "/" +
                    this.versionDate.substring(0, 4);
            }

            // sirina col1+col2
            this.add = document.getElementById("col1").getBoundingClientRect().width +
                document.getElementById("col2").getBoundingClientRect().width;

            this.col3Width = document.getElementById("timeline").clientWidth - this.add;
            //document.getElementById("col3").style.width = this.col3Width + "px";

            this.firstYear = 1945;
            if (this.acts.length > 0) {
                this.firstYear = new Date(this.acts[0].versionApplicationDate).getFullYear();
                this.dates[0] = "1/1/" + this.firstYear;
            }

            for (let i = 0; i < this.acts.length; i++) {
                this.dates[i + 1] = new Date(this.acts[i].versionApplicationDate).getDate() + "/" +
                    (new Date(this.acts[i].versionApplicationDate).getMonth() + 1) + "/" +
                    new Date(this.acts[i].versionApplicationDate).getFullYear();

                if (this.dates[i + 1] === this.dateV) {
                    this.index = i + 1;
                }
            }

            this.dates.push(new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear());

            if (this.dateV === "") {
                this.index = this.dates.length - 2;
            }

            // var endYear = new Date().getFullYear();
            // niz sa godinama ispod ose od 1945 do 2046
            this.indexFirstYear = 0;

            for (let k = this.startYear; k <= 2046; k++) {
                this.yearsUnder[k - this.startYear] = new Date(k, 0, 1);

                if (k === this.firstYear) {
                    this.indexFirstYear = k - this.startYear;
                }
            }

            this.indexFirstYear = this.indexFirstYear - (this.indexFirstYear % 5); // prva prethodna godina deljiva sa 5

            // danasnji datum, crvena linija
            this.yearsUnder.push(new Date());
            this.makeCircles();
        },
        dateSpan(date) {
            var day = date.split('/')[0];
            if (day.charAt(0) == '0') {
                day = day.charAt(1);
            }
            var year = date.split('/')[2];

            return day + "." + date.split('/')[1] + "." + year;
        },
        makeCircles() {
            // prikazujemo timeline za akte koji imaju bar jednu promenu
            if (this.acts.length < 1) {
                window.$("#timeline").hide();
            } else {
                const firstYear = this.firstYear - (this.firstYear % 5);
                const lastYear = new Date().getFullYear() + 3;
                const lastInt = (lastYear - firstYear) * 365;
                const move = 3; // poluprecnik kruzica na osi
                const movebox = 75; // sirina oblacica gde se nalazi datum
                const addStyle = "font-weight: bold; color: white;";
                let thisMonth;
                let thisDay;
                let thisYear;
                let relativeInt;
                let thisInt;
                let x;
                let elem;
                let rect;
                let xCircle;
                let xBox;
                let xCircleU;

                this.posYearsInPx[this.indexFirstYear] = 0;
                window.$("#under").append(`<div class="vis-year" id="year${this.indexFirstYear}" style="left: ${0}px; color:green;font-weight: bold;">${this.yearsUnder[this.indexFirstYear].getFullYear()}</div>`);
                window.$("#line").append(`<div class="circleU" id="circleU${this.indexFirstYear}" style="left:${-move}px;"></div>`);

                if (this.index === -1) {
                    this.index = this.acts.length > 1 ? this.dates.length - 2 : 1;
                }

                for (let i = 1; i < this.dates.length; i++) {
                    thisMonth = parseInt(this.dates[i].split('/')[1]);
                    thisDay = parseInt(this.dates[i].split('/')[0]);
                    thisYear = parseInt(this.dates[i].split('/')[2]);
                    thisInt = (thisYear - firstYear) * 365 + (thisMonth - 1) * 30 + (thisDay - 1);

                    // pozicija datuma na osi i vertikalne linije, kruzici se pomeraju u levo za poluprecnik (move), a oblacici za pola duzine (movebox/2)
                    relativeInt = thisInt / lastInt;
                    // this.distanceCircle[i] = relativeInt * 100;

                    if (i !== this.index && i !== this.dates.length - 1) {
                        window.$("#box").append(`<div class="vis-item vis-box" id="box${i}" style="left:${relativeInt * 100}%; top: 15px;"><div class="vis-item-content"><span>${this.dateSpan(this.dates[i])}</span></div></div>`);
                        elem = document.getElementById(`box${i}`);
                        rect = elem.getBoundingClientRect();
                        x = rect.left - this.add;
                        xBox = x - movebox / 2;
                        xCircle = x - move;
                        this.posActsInPx[i] = x;
                        document.getElementById(`box${i}`).style.left = `${xBox}px`;
                        window.$("#vertLine").append(`<div class="vis-item vis-line" id="line${i}" style="left:${x}px; top: 5px; height: 45px;"></div>`);
                        window.$("#line").append(`<div class="circle" id="circle${i}" style="left: ${xCircle}px;"></div>`);
                    } else if (i === this.dates.length - 1) {
                        // poslednji element nema oblacic sa datumom
                        window.$("#box").append(`<div class="vis-item vis-box" id="box${i}" style="visibility: hidden; left:${relativeInt * 100}%; top: 15px;"><div class="vis-item-content"><span>${this.dateSpan(this.dates[i])}</span></div></div>`);
                        elem = document.getElementById(`box${i}`);
                        rect = elem.getBoundingClientRect();
                        x = rect.left - this.add;
                        xBox = x - movebox / 2;
                        xCircle = x - move;
                        this.posActsInPx[i] = x;
                        document.getElementById(`box${i}`).style.left = `${xBox}px`;
                        window.$("#vertLine").append(`<div class="vis-item vis-line" id="line${i}" style="left:${x}px; bottom: 5px; top:-32px; height: 84px; border-color:red;"></div>`);
                        window.$("#line").append(`<div class="circle" id="circle${i}" style="left: ${xCircle}px;"></div>`);
                    } else {
                        // ovo je naznaceni datum za koji se odredjuje promena, treba da bude istaknut
                        window.$("#box").append(`<div class="vis-item vis-box1" id="box${i}" style="left:${relativeInt * 100}%; top: 15px; z-index: 1; ${addStyle}"><div class="vis-item-content"><span>${this.dateSpan(this.dates[this.index])}</span></div></div>`);
                        elem = document.getElementById(`box${i}`);
                        rect = elem.getBoundingClientRect();
                        x = rect.left - this.add;
                        xBox = x - movebox / 2;
                        xCircle = x - move;
                        this.posActsInPx[i] = x;
                        document.getElementById(`box${i}`).style.left = `${xBox}px`;
                        window.$("#vertLine").append(`<div class="vis-item vis-line" id="line${this.index}" style="left:${x}px; top: 5px; height: 45px; border-color:green; z-index: 1;"></div>`);
                        window.$("#line").append(`<div class="circle" id="circle${i}" style="left: ${xCircle}px; z-index: 1;"></div>`);
                    }
                    var self = this;
                    window.$(`#box${i}`).on('click', function () {
                        self.addOnClick(i);
                    });
                    window.$(`#line${i}`).on('click', function () {
                        self.addOnClick(i);
                    });
                }

                let yearVisible;
                let curcleUVisible;

                // iscrtavanje godina ispod linije
                for (let j = 0; j < this.yearsUnder.length; j++) {
                    if (j !== this.indexFirstYear && this.yearsUnder[j].getMonth() === 0 && this.yearsUnder[j].getDate() === 1) {
                        thisYear = this.yearsUnder[j].getFullYear();
                        thisInt = (thisYear - firstYear) * 365;
                        relativeInt = thisInt / lastInt;

                        if (new Date().getFullYear() == thisYear) {
                            window.$("#under").append(`<div class="vis-year" id="year${j}" style="left: ${relativeInt * 100}%;color:green; font-weight: bold;">${thisYear}</div>`);
                            elem = document.getElementById(`year${j}`);
                            rect = elem.getBoundingClientRect();
                            this.posYearsInPx[j] = rect.left - this.add;
                            document.getElementById(`year${j}`).style.left = `${rect.left - this.add}px`;
                            this.currentYearInd = j;
                        } else {
                            window.$("#under").append(`<div class="vis-year" id="year${j}" style="left: ${relativeInt * 100}%;">${thisYear}</div>`);
                            elem = document.getElementById(`year${j}`);
                            rect = elem.getBoundingClientRect();
                            this.posYearsInPx[j] = rect.left - this.add;
                            document.getElementById(`year${j}`).style.left = `${rect.left - this.add}px`;
                        }

                        xCircleU = rect.left - move - this.add;
                        window.$("#line").append(`<div class="circleU" id="circleU${j}" style="left: ${xCircleU}px;"></div>`);
                        yearVisible = `year${j}`;
                        curcleUVisible = `circleU${j}`;

                        if (thisYear % 10 === 5 || thisYear === new Date().getFullYear()) {
                            document.getElementById(yearVisible).style.visibility = "visible";
                            document.getElementById(curcleUVisible).style.visibility = "visible";
                        } else {
                            document.getElementById(yearVisible).style.visibility = "hidden";
                            document.getElementById(curcleUVisible).style.visibility = "hidden";
                        }
                    }
                }


            }
        },
        scrollZoomIn(inOut, pos) {
            //this.changeFont();
            const dist = this.posYearsInPx[1] - this.posYearsInPx[0];
            const move = 3;
            const movebox = 75;
            let distY;

            for (let j = 0; j < this.yearsUnder.length - 1; j++) {
                distY = pos - this.posYearsInPx[j];
                this.posYearsInPx[j] = pos - distY * inOut;
                document.getElementById(`year${j}`).style.left = `${this.posYearsInPx[j]}px`;
                document.getElementById(`circleU${j}`).style.left = `${this.posYearsInPx[j] - move}px`;

                if (dist >= 30) {
                    document.getElementById(`year${j}`).style.visibility = 'visible';
                    document.getElementById(`circleU${j}`).style.visibility = 'visible';
                }
            }

            const a = document.getElementsByClassName("circle");
            for (let k = a.length; k > 0; k--) {
                distY = pos - this.posActsInPx[k];
                this.posActsInPx[k] = pos - distY * inOut;
                document.getElementById(`line${k}`).style.left = `${this.posActsInPx[k]}px`;
                document.getElementById(`circle${k}`).style.left = `${this.posActsInPx[k] - move}px`;
                document.getElementById(`box${k}`).style.left = `${this.posActsInPx[k] - movebox / 2}px`;
            }
        },
        scrollZoomOut(inOut, pos) {
            //this.changeFont();
            const dist = this.posYearsInPx[1] - this.posYearsInPx[0];
            const move = 3;
            const movebox = 75;
            let distY;

            if (dist >= 20) {
                for (let j = 0; j < this.yearsUnder.length - 1; j++) {
                    distY = pos - this.posYearsInPx[j];
                    this.posYearsInPx[j] = pos - distY * inOut;
                    document.getElementById(`year${j}`).style.left = `${this.posYearsInPx[j]}px`;
                    document.getElementById(`circleU${j}`).style.left = `${this.posYearsInPx[j] - move}px`;

                    if (dist < 45 && this.yearsUnder[j].getFullYear() % 10 !== 5) {
                        document.getElementById(`year${j}`).style.visibility = 'hidden';
                        document.getElementById(`circleU${j}`).style.visibility = 'hidden';
                    }
                }

                const a = document.getElementsByClassName("circle");
                for (let k = a.length; k > 0; k--) {
                    distY = pos - this.posActsInPx[k];
                    this.posActsInPx[k] = pos - distY * inOut;
                    document.getElementById(`line${k}`).style.left = `${this.posActsInPx[k]}px`;
                    document.getElementById(`circle${k}`).style.left = `${this.posActsInPx[k] - move }px`;
                    document.getElementById(`box${k}`).style.left = `${this.posActsInPx[k] - movebox / 2 }px`;
                }
            } else {
                for (let m = 0; m < this.yearsUnder.length - 2; m++) {
                    if (this.yearsUnder[m].getFullYear() % 10 !== 5) {
                        document.getElementById(`year${m}`).style.visibility = 'hidden';
                        document.getElementById(`circleU${m}`).style.visibility = 'hidden';
                    }
                }
            }

            if (this.posYearsInPx[0] > 0) {
                this.onTranslateX(-this.posYearsInPx[0]);
                document.getElementById("year0").style.color = "green";
                document.getElementById("year0").style.fontWeight = "bold";
            }
        },

        zoomOnClick() {
            //this.changeFont();
            const index = this.posActsInPx.length - 1;
            const dist = this.posYearsInPx[1] - this.posYearsInPx[0];
            const move = 3;
            const movebox = 75;
            let distY;

            for (let j = 0; j < this.yearsUnder.length - 2; j++) {
                distY = this.posActsInPx[index] - this.posYearsInPx[j];
                this.posYearsInPx[j] = this.posActsInPx[index] - distY * 1.5;
                document.getElementById(`year${j}`).style.left = this.posYearsInPx[j] + "px";
                document.getElementById(`circleU${j}`).style.left = this.posYearsInPx[j] - move  + "px";

                if (dist >= 30) {
                    document.getElementById(`year${j}`).style.visibility = "visible";
                    document.getElementById(`circleU${j}`).style.visibility = "visible";
                }
            }

            const a = document.getElementsByClassName("circle");
            for (let k = a.length - 1; k > 0; k--) {
                distY = this.posActsInPx[index] - this.posActsInPx[k];
                this.posActsInPx[k] = this.posActsInPx[index] - distY * 1.5;
                document.getElementById(`line${k}`).style.left = (this.posActsInPx[k] ) + "px";
                document.getElementById(`circle${k}`).style.left = (this.posActsInPx[k] - move ) + "px";
                document.getElementById(`box${k}`).style.left = (this.posActsInPx[k] - movebox / 2 ) + "px";
            }
        },

        zoomOutClick() {
            //this.changeFont();
            const index = this.posActsInPx.length - 1;
            const dist = this.posYearsInPx[this.currentYearInd] - this.posYearsInPx[this.currentYearInd - 1];
            const move = 3;
            const movebox = 75;
            let distY;

            if (dist >= 20) {
                for (let j = 0; j < this.yearsUnder.length - 2; j++) {
                    distY = this.posActsInPx[index] - this.posYearsInPx[j];
                    this.posYearsInPx[j] = this.posActsInPx[index] - distY * 0.5;
                    document.getElementById(`year${j}`).style.left = (this.posYearsInPx[j] ) + "px";
                    document.getElementById(`circleU${j}`).style.left = (this.posYearsInPx[j] - move) + "px";

                    if (dist < 45 && this.yearsUnder[j].getFullYear() % 10 !== 5) {
                        document.getElementById(`year${j}`).style.visibility = "hidden";
                        document.getElementById(`circleU${j}`).style.visibility = "hidden";
                    }
                }

                const a = document.getElementsByClassName("circle");
                for (let k = a.length - 1; k > 0; k--) {
                    distY = this.posActsInPx[index] - this.posActsInPx[k];
                    this.posActsInPx[k] = this.posActsInPx[index] - distY * 0.5;
                    document.getElementById(`line${k}`).style.left = (this.posActsInPx[k] ) + "px";
                    document.getElementById(`circle${k}`).style.left = (this.posActsInPx[k] - move )+ "px";
                    document.getElementById(`box${k}`).style.left = (this.posActsInPx[k] - movebox / 2 ) + "px";
                }
            } else {
                for (let m = 0; m < this.yearsUnder.length - 2; m++) {
                    if (this.yearsUnder[m].getFullYear() % 10 !== 5) {
                        document.getElementById(`year${m}`).style.visibility = "hidden";
                        document.getElementById(`circleU${m}`).style.visibility = "hidden";
                    }
                }
            }

            if (this.posYearsInPx[0] > 0) {
                this.onTranslateX(-this.posYearsInPx[0]);
                document.getElementById(`year0`).style.color = "green";
                document.getElementById(`year0`).style.fontWeight = "bold";
            }
        },

        zoom(event) {
            event.preventDefault();
            this.scale += event.deltaY * -0.01;
            this.scale = Math.min(Math.max(0.125, this.scale), 4);
            const pos = event.clientX - this.add;
            if (this.scale > 1) this.scrollZoomIn(1.5, pos);
            else this.scrollZoomOut(0.5, pos);
        },

        onTranslateX(x) {
            //this.changeFont();
            const move = 3;
            const movebox = 75;

            for (let l = 0; l < this.posYearsInPx.length; l++) {
                this.posYearsInPx[l] = this.posYearsInPx[l] + x;
                document.getElementById("year" + l).style.left = (this.posYearsInPx[l]) + 'px';
                document.getElementById("circleU" + l).style.left = (this.posYearsInPx[l] - move ) + 'px';
            }

            for (let i = 1; i < this.dates.length; i++) {
                this.posActsInPx[i] += x;
                document.getElementById("line" + i).style.left = (this.posActsInPx[i] ) +'px';
                document.getElementById("circle" + i).style.left = (this.posActsInPx[i] - move) + 'px';
                document.getElementById("box" + i).style.left = (this.posActsInPx[i] - move - movebox / 2 ) + 'px';
            }

            if (x > 0) {
                if (this.posYearsInPx[0] > 0) {
                    this.onTranslateX(-this.posYearsInPx[0]);
                }
            }
        },

        undoOnClick() {
            this.clearElement("box");
            this.clearElement("vertLine");
            this.clearElement("line");
            this.clearElement("under");
            this.makeCircles();
        },
        clearElement(elementId) {
            var myNode = document.getElementById(elementId);
            if (myNode) {
                myNode.innerHTML = "";
            }
        },

        onMouseDown(event) {
            event.preventDefault();
            this.coordinatX1 = event.clientX;
            this.coordinatX2 = this.coordinatX1;
            window.addEventListener("mousemove", this.onMouseMove);
        },

        onMouseMove(event) {
            this.coordinatX3 = event.clientX;
            this.onTranslateX(this.coordinatX3 - this.coordinatX2);
            this.coordinatX2 = this.coordinatX3;
        },

        onMouseUp(event) {
            this.coordinatX2 = event.clientX;
            window.removeEventListener("mousemove", this.onMouseMove);
        },

        addOnClick(ind) {
            const date = this.dates[ind];
            const x = date.substring(date.indexOf("/") + 1);
            const mm = x.substring(0, x.indexOf("/")).length === 1 ? "0" + x.substring(0, x.indexOf("/")) : x.substring(0, x.indexOf("/"));
            const dd = date.substring(0, date.indexOf("/")).length === 1 ? "0" + date.substring(0, date.indexOf("/")) : date.substring(0, date.indexOf("/"));
            const addDate = date.substring(date.length - 4) + mm + dd;
            
            if(window.location.href.indexOf('/reg') != -1) {
                this.url = window.location.href.substring(0, window.location.href.indexOf("/reg"));
                window.location.href = this.url + "/reg/" + addDate;
            }
            else {
                this.url = window.location.href;
                const regex = /\/(\d{8})$/;
                var dateAlreadyExistInLink = this.url.match(regex);
                if(dateAlreadyExistInLink)
                    window.location.href = this.url.replace(dateAlreadyExistInLink[1], addDate);
                else window.location.href = this.url + "/" + addDate;
            }

        },
    },
    beforeDestroy() {
        const el = document.querySelector('#timeline');
        el.removeEventListener('wheel', this.zoom);
    },
}
</script>

<style>
#under {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: -moz-none;
    -o-user-select: none;
    user-select: none;
}

#leftBtn {
    width: 28px;
    height: 28px;
    background-image: url("pageresource/timeline/plusTimeline.png");
    background-repeat: no-repeat;
    background-position: centar;
}


#rightBtn {
    width: 28px;
    height: 28px;
    background-image: url("pageresource/timeline/plusTimeline.png");
    background-repeat: no-repeat;
    background-position: centar;
}

#plusBtn {
    width: 28px;
    height: 28px;
    background-image: url("pageresource/timeline/plusTimeline.png");
    background-repeat: no-repeat;

}

#minusBtn {
    width: 28px;
    height: 28px;
    background-image: url("pageresource/timeline/minusTimeline.png");
    background-repeat: no-repeat;
}

#undoBtn {
    width: 28px;
    height: 28px;
    background-image: url("pageresource/timeline/undoTimeline.png");
    background-repeat: no-repeat;

}

#before45 {
    background-image: url("pageresource/timeline/before45Timeline.png");
    background-position: bottom;
    /*background-repeat: no-repeat;*/
    padding: 0;
    border: 1px solid #ccc;
    height: 28px;
    position: relative;
    bottom: 0;
    /*width: 317px;*/
    /*bottom:4px;*/
    left: 0;
    z-index: 1;
    opacity: 1;
}

#after45 {
    padding: 0;
    height: 84px;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 1;
    background: #ffffff;
}

#btnGroup {
    width: 28px;
    height: 51px;
    float: right;
}

.groupHor {
    height: 17px;
}

.col1 {
    float: left;
    padding: 0;
    float: left;
    position: relative;
    padding: 0;

}
@media (min-width: 575px) {
  .col1 {
    display: block !important;
  }
}
@media (max-width: 575px) {
  .col1 {
    display: none !important;
  }
  .col3 {
    width: calc(100% - 30px) !important;
  }
}

.col2 {
    position: relative;
    float: left;
    width: 28px;
    height: 112px;
    left: 0;
    z-index: 1;
    opacity: 1;
    background: #ffffff;
    padding: 0;

}

.col3 {
    position: relative;
    float: left;
    padding: 0;
    overflow: hidden;
    left: 0;
    width: calc(83.3333333333% - 30px);
    
}

#start2 {
    background: white;
    background-image: linear-gradient(to right, #6c757d 40%, rgba(255, 255, 255, 0) 10%);
    background-position: top;
    background-size: 5px 2px;
    background-repeat: repeat-x;
    height: 30px;
    width: 28px;
    position: absolute;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid #ccc;
}

#start1 {
    padding: 0;
    position:
        absolute;
    left: 0;
    height: 84px;
    top: 0
}

#group {
    float: right;
    padding-left: 240px;
    padding-right: 0;
}

#move {
    position: absolute;
    top: 0;
    left: 0;
}

#lineCont {
    width: 100%;
    height: 25px;
    position: absolute;
}

#line {
    height: 1px;
    width: 100%;
    /*  background: #bcbcbc;
/**    border-radius: 5px;
*	border: thin dotted; **/
    background: white;
    background-image: linear-gradient(to right, #333 40%, rgba(255, 255, 255, 0) 10%);
    background-position: top;
    background-size: 5px 1px;
    background-repeat: repeat-x;
    margin: auto;
    top: 50%;
    /* top: 25px; */
    transform: translateY(-50%);
    position: relative;
    cursor: pointer;
    margin-left: -37px;

}

#box {
    width: 100% !important;
    margin: auto !important;
    transform: translateY(-50%) !important;
    position: relative !important;
    cursor: pointer !important;
    height: 30px !important;
}

#vertLine {
    width: 100%;
    margin: auto;
    transform: translateY(-50%);
    position: relative;
    cursor: pointer;
}

#span {
    display: none !important;
    width: 70% !important;
    margin: auto !important;
    margin-top: 25% !important;
    text-align: center !important;
    color: green !important;
}

.circleU {
    width: 6px;
    height: 6px;
    background: #ffffff;
    border-radius: 15px;
    position: absolute;
    top: -3px;
    border: 1px solid #bcbcbc;
    cursor: pointer;
    margin-left: 37px;

}

.circleU::before {
    content: '';
    width: 10px;
    height: 10px;
    background: white;
    position: absolute;
    border-radius: 100%;
    top: 2px;
    left: 2px;
    display: none;
}

.circle {
    width: 6px;
    height: 6px;
    background: #ffffff;
    border-radius: 15px;
    position: absolute;
    top: -3px;
    border: 1px solid green;
    cursor: pointer;
    margin-left: 37px;

}

.circle::before {
    content: '';
    width: 10px;
    height: 10px;
    background: white;
    position: absolute;
    border-radius: 100%;
    top: 2px;
    left: 2px;
    display: none;
}

.popupSpan {
    width: auto;
    height: auto;
    padding: 10px;
    white-space: nowrap;
    display: inline-block;
    color: red;
    position: absolute;
    top: 20px;
    left: -200%;
}

.circle.hover::before,
.circle.active::before {
    display: block;
}

.circle.hover .popupSpan,
.circle.active .popupSpan {
    display: block;
}

.circle.active .popupSpan {
    top: -40px;
}


#mainCont {
    height: 30%;
    width: 100%;
    position: relative;
    color: white;
    font-size: 16px;
    text-align: center;
    /* transition: all 0.2s ease-out; */
}

#mainCont span {
    display: inline-block !important;
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
    top: 30% !important;
    /*  transition: all 0.2s ease-out; */
}

#mainCont span.right {
    left: 200% !important;
}

/*  #mainCont span.center { */
/*       left: 0% !important; */
/*    } */
#mainCont span.left {
    left: -100% !important;
}

.proba {
    margin-top: 0;
    height: 112px;
    /*margin-bottom: 25px;*/
    border-bottom: 1px #ccc solid;
    background: #fff;
}

#lineBox {
    height: 35px;
    width: 100%;
    position: relative;
}

#lineUnder {
    height: 30px;
    width: 100%;
    position: relative;
    display: inline-block;
    cursor: all-scroll;

}

#lineVert {
    height: 24px;
    width: 100%;
    position: relative;
}

.vis-item {
    position: absolute;
    color: green;

    display: inline-block;


    font-size: 9px;
}

.vis-item.vis-box {
    text-align: center;
    background-image: url("pageresource/timeline/box.png") !important;
    background-repeat: no-repeat;
    width: 75px;
    height: 30px;


}

.vis-item.vis-box1 {
    text-align: center;
    background-image: url("pageresource/timeline/box_green.png");
    background-repeat: no-repeat;
    width: 75px;
    height: 30px;
    z-index: 1;

}

.vis-item .vis-item-content {
    white-space: nowrap;
    box-sizing: border-box;
    padding: 5px;
    font-weight: 550;
    font-size: 12px;
    font-family: Open Sans, sans-serif !important;
}

.vis-item.vis-line {
    padding: 0;
    position: absolute;
    width: 0;
    border-left-width: 1px;
    border-left-style: solid;
    border-color: #ccc;
    bottom: -1px;
    top: -5px;
    height: 50px;
}

.vis-item.vis-line1 {
    padding: 0;
    position: absolute;
    width: 0;
    border-left-width: 1px;
    border-left-style: solid;
    border-color: green;
    bottom: -1px;
    top: -5px;
    height: 50px;
}

.vis-year {
    padding: 7px 0 0 5px;
    position: absolute;
    border-left-width: 1px;
    border-left-style: solid;
    top: 2px;
    height: 20px;
    border-color: #bcbcbc;
    font-family: Open Sans, sans-serif !important;
    color: #777;
    font-size: 9px;
    display: inline-block;
    font-weight: bold;

}

.vis-item:hover {
    background-image: url("pageresource/timeline/box_hover.png");
    background-repeat: no-repeat;
    color: green;
    cursor: pointer;
    display: block;
    z-index: 2;
}

.vis-item a {
    color: #1078a6;
}

.items {
    position: relative;
    white-space: nowrap;
    /*will-change: transform;*/
    user-select: none;
    /* overflow-x: auto;*/
    overflow-y: hidden;
    padding-left: 5px;
    padding-right: 5px;
}

.lineDiv {
    width: calc(100% - 35px); 
    margin-left: 37px;
}
/* @media screen and (max-width: 990px) {
    #timeline {
        display: none;
    }
} */
</style>
